<template>
    <Paginator :rows="pageSize" v-model:first="text" :totalRecords="total" :pageLinkSize="pagerCount" :rowsPerPageOptions="rowsPerPageOptions" :alwaysShow="alwaysShow" style="display: inline-block;"></Paginator>
</template>

<script>
import { computed } from 'vue'
import Paginator from 'primevue/paginator';

export default {
    name: 'tw-pagination',
    components: {
        Paginator
    },
    setup(props, context){
        const text = computed({
            get() {
                return (props.currentPage === null || props.currentPage === undefined) ? 0 : props.currentPage * props.pageSize
            },
            set(value){
                context.emit('update:current-page', Math.ceil(value / props.pageSize))
            }
        })

        const rowsPerPageOptions = computed(() => {
            return props.pageSizes ? JSON.parse(props.pageSizes) : null
        })

        return {
            text,
            rowsPerPageOptions
        }
    },
    props: {
        pageSize: Number,
        total: Number,
        currentPage: Number,
        pageSizes: String,
        pagerCount: Number,
        alwaysShow: Boolean
    }
}
</script>
